import React from 'react';

import { MainWrapper } from '../main-wrapper';
import { MiniModalLoadingContent } from './MiniModalLoadingContent';

export const MiniModalLoadingFallbackComponent = ({
	topOffset,
	isNav4Enabled,
	openAtMaxSize,
}: {
	topOffset: number;
	isNav4Enabled: boolean;
	openAtMaxSize?: boolean;
}): JSX.Element => {
	return (
		<MainWrapper mode="mini-modal" isNav4Enabled={isNav4Enabled}>
			<MiniModalLoadingContent topOffset={topOffset} openAtMaxSize={openAtMaxSize} />
		</MainWrapper>
	);
};
